<template>
  <div v-loading="pageLoading">
    <div>
      <!-- 搜索 -->
      <el-form :inline="true"
               class="demo-form-inline">
        <el-form-item label="分公司">
          <el-select v-model="regionNames"
                     multiple filterable
                     placeholder="請選擇分公司">
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.regionName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業">
          <el-select v-model="branchNames"
                     multiple filterable
                     placeholder="請選擇部門/物業">
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.branchName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn"
                     @click="onSubmit">搜尋</el-button>
          <el-button type="primary"
                     @click="add">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <template>
        <el-table ref="singleTable"
                  :data="tableData"
                  empty-text="暫無記錄"
                  style="width: 100%"
                  border
                  @sort-change="sort">
          <el-table-column type="index"
                           label="序號"
                           width="120"></el-table-column>
          <el-table-column property="regionName"
                           label="分公司"></el-table-column>
          <el-table-column property="branchName"
                           label="部門/物業"></el-table-column>
          <el-table-column property="branchCode"
                           label="物業編碼"></el-table-column>
          <el-table-column property="contactWay"
                           label="聯繫方式"></el-table-column>
          <el-table-column property="creationTime"
                           sortable="custom"
                           label="創建時間"></el-table-column>
          <el-table-column label="操作"
                           width="145">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="warning"
                         @click="edit(scope.row.id,scope.row.regionName)">編輯</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="open(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <el-pagination :hide-on-single-page="true"
                     :total="total"
                     layout="prev, pager, next,total"
                     @current-change="pageChange"></el-pagination>

      <!-- 彈窗 -->
      <el-dialog :title="title"
                 :visible.sync="dialogFormVisible"
                 width="550px"
                 :before-close="dialogClose">
        <el-form :model="form" ref="form">
          <el-form-item label="分公司"
                        :label-width="formLabelWidth">
            <el-select v-model="form.manRegionId"
                       :placeholder="dialogDataLoading ? '加載中' : '請選擇分公司'"
                       style="width: 80%;"
                       :disabled="dialogDataLoading || dialogLoading"
                      @change="selectRegion"
                      >
              <el-option v-for="item in region"
                         :key="item.id"
                         :label="item.regionName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部門/物業"
                        :label-width="formLabelWidth">
            <el-input v-model="form.branchName"
                      :placeholder="dialogDataLoading ? '加載中' : '請輸入部門/物業名稱'"
                      style="width: 80%;"
                      :disabled="dialogDataLoading || dialogLoading"></el-input>
          </el-form-item>
          <el-form-item label="物業編碼"
                        :label-width="formLabelWidth">
            <el-input v-model="form.branchCode"
                      :placeholder="dialogDataLoading ? '加載中' : '請輸入物業編碼'"
                      style="width: 80%;"
                      :disabled="dialogDataLoading || dialogLoading"></el-input>
          </el-form-item>
          <el-form-item label="聯繫方式"
                        :label-width="formLabelWidth">
            <el-input v-model="form.areaCode"
                      placeholder="區號"
                      style="width:20%;"
                      :disabled="dialogDataLoading || dialogLoading"></el-input>
            <el-input v-model="form.phone"
                      placeholder="固定電話"
                      style="width:35%;"
                      :disabled="dialogDataLoading || dialogLoading"></el-input>
            <el-input v-model="form.extension"
                      placeholder="(分機選填)"
                      style="width:25%;"
                      :disabled="dialogDataLoading || dialogLoading"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button @click="filialeE">取 消</el-button> 
          <el-button type="primary"
                     @click="filialeM"
                     :loading="dialogLoading">確 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      regionNames: [],
      branchNames: [],
      query: {
        branchNames: '',
        pageSize: 10,
        pageNum: 1,
        sortAsc: '',
        sortDesc: 'creationTime'
      },
      form: {
        manRegionId: '',
        branchName: '',
        areaCode: '',
        phone: '',
        extension: '',
        branchCode:null,
      },
      regionName:'',
      regionId:'',
      regionIdData:'',
      organization:'',
      formLabelWidth: '100px',
      tableData: [],
      filiale: [],
      dialogFormVisible: false,
      title: '',
      region: [],
      total: 0,
      id: '',

      dialogDataLoading: false,
      dialogLoading: false,
    };
  },
  created () {
    that = this;
  },
  mounted () {
    $('#pageHead').text('部門/物業管理');
    this.loadMsg();
    // 分公司
    this.$store.dispatch('commonData/getBranchList').then(() => {
      this.filiale = this.$store.state.commonData.branchList
    })
    // 地區
    this.$store.dispatch('commonData/getRegionList').then(() => {
      this.region = this.$store.state.commonData.regionList
    })
  },
  methods: {
    onSubmit () {
      that.query.pageNum = 1;
      that.loadMsg();
    },
    sort (msg) {
      var prop = msg.prop,
        order = msg.order,
        formInline = this.query;
      if (order == 'ascending') {
        formInline.sortDesc = prop;
        formInline.sortAsc = '';
      } else {
        formInline.sortDesc = '';
        formInline.sortAsc = prop;
      }
      that.loadMsg();
    },
    filialeM () {
      var form = this.form;
      for (let item in form) {
        if (form[item] == '' && item != 'extension' && item != 'branchCode') {
          that.$message({
            type: 'warning',
            message: '請將數據填寫完整!'
          });
          return;
        }
      }
      // if (!form.areaCode.match(/^0\d{2,3}$/) || !form.phone.match(/^\d{7,8}$/)) {
      // 	that.$message({
      // 		type: 'warning',
      // 		message: '請填寫正確的聯繫方式!'
      // 	});
      // 	return;
      // }
      if (form.phone == '' || !form.phone.match(/^\d{0,}$/)) {
        that.$message({
          type: 'warning',
          message: '請填寫正確的聯繫方式!'
        });
        return;
      }
      delete form.id;
      this.dialogLoading = true
      if (this.title == '新增') {
        this.axios({
          url: '/manage/addManBranch',
          method: 'post',
          params: form
        }).then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            that.form = {
            manRegionId: '',
            branchName: '',
            areaCode: '',
            phone: '',
            extension: '',
            branchCode:null,
          };

            that.loadMsg();
            this.dialogFormVisible = false;
            this.dialogLoading = false
            this.loadMsg();
            // 更新vuex中branch相关缓存
            this.branch = []
            this.$store.dispatch('commonData/updateBranchList').then(() => {
              this.branch = this.getDistinctBranchNameList
            })
            this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
            this.$store.commit('commonData/setRelevanceList', [])
          }
        }).catch(() => {
          // this.$message({
          //   type: 'warning',
          //   message: e
          // })
          this.dialogLoading = false
        })
      } else {
  
              form['id'] = this.id;
              form['regionId'] = this.regionIdData;
                this.axios({
                  url: '/manage/updateManBranch',
                  method: 'post',
                  params: form
                }).then(res => {
                  if (res) {
                    this.$message({
                      type: 'success',
                      message: '修改成功!'
                    });
                    this.form = {
                    manRegionId: '',
                    branchName: '',
                    areaCode: '',
                    phone: '',
                    extension: '',
                    branchCode:null
                  };
                    that.loadMsg();
                    this.dialogFormVisible = false;
                    this.dialogLoading = false
                    this.loadMsg();
                    // 更新vuex中branch相关缓存
                    this.branch = []
                    this.$store.dispatch('commonData/updateBranchList').then(() => {
                      this.branch = this.getDistinctBranchNameList
                    })
                    this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
                    this.$store.commit('commonData/setRelevanceList', [])
                  }
                }).catch(e => {
                  // console.log(e.code);
                  // console.log(e);
                    if(e!="请先解绑分公司下的员工"){
                    this.$message({
                        type: 'warning',
                        message: e
                    })
               }
                  
                 
                  this.dialogLoading = false
                })
      }
    },

    filialeE () {
      this.dialogFormVisible = false;
      this.form = {
        manRegionId: '',
        branchName: '',
        areaCode: '',
        phone: '',
        extension: '',
        branchCode:null
      };

    },
    add () {
      // 新增
      this.title = '新增';
      this.dialogFormVisible = true;
      // this.form = {
      //   manRegionId: '',
      //   branchName: '',
      //   areaCode: '',
      //   phone: '',
      //   extension: '',
      //   branchCode:''
      // }
    },
    pageChange (val) {
      // 切換頁碼
      that.query.pageNum = val;
      that.loadMsg();
    },
    open (id) {
      this.$confirm('確認刪除該分公司？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '確定',
        type: 'warning'
      })
        .then(() => {
          this.axios({ url: '/manage/delManBranch', params: { id }, method: 'post' }).then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.loadMsg();
              // 更新vuex中branch相关缓存
              this.branch = []
              this.$store.dispatch('commonData/updateBranchList').then(() => {
                this.branch = this.getDistinctBranchNameList
              })
              this.$store.commit('commonData/setEchoDistrictBranchDepartmentList', [])
              this.$store.commit('commonData/setRelevanceList', [])
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    edit (id,regionName) {
      //title需要更换“修改” 二字时需要进行修改selectRegion()的判断...重要
      this.title = '修改';
      this.dialogDataLoading = true;
      this.regionName = regionName;
      this.axios({
        url: '/manage/getManBranch',
        params: {
          id: id
        }
      }).then(res => {
        var form = this.form, msg = res.result[0];
        form.manRegionId = msg.manRegionId
        form.branchName = msg.manBranchName
        form.areaCode = msg.areaCode
        form.phone = msg.contactWay
        form.extension = msg.extension
        form.branchCode = msg.branchCode
        this.id = msg.id;
        this.regionId = msg.manRegionId
        this.dialogDataLoading = false
        
      });
      this.dialogFormVisible = true;
    },
     //进行判断修改再更换公司时是否有人员绑定在改分公司下
     selectRegion(e){
        //  console.log("----"+this.regionName+"----"+this.regionId);
        //  console.log("----"+e);
        
         if(e!=this.regionId){
            this.regionIdData = this.regionId;
            if(this.title == '修改'){
                this.axios({
                    url: '/manage/getBindingOrganization',
                    method: 'get',
                    params: {
                      regionId:this.regionId,
                    },
                }).then(res =>{
                      if (res.code==200) {
                          if(res.result!=null){
                              this.$message({
                              type: 'warning',
                              message: "请先解绑公司:  <" +this.regionName + ">  下的员工"
                            });
                          }
                        }
                    }
                  )
              }
         }else{
            this.regionIdData =null;
         }

    },


    loadMsg () {
      if (this.regionNames && this.regionNames.length > 0) {
        this.query.regionNames = this.regionNames;
      } else {
        delete this.query.regionNames
      }
      if (this.branchNames && this.branchNames.length > 0) {
        this.query.branchNames = this.branchNames;
      } else {
        delete this.query.branchNames
      }
      this.pageLoading = true
      this.axios({
        url: '/manage/getManBranchList',
        params: that.query,
        paramsSerializer: params => {
          return that.qs.stringify(params, {
            arrayFormat: 'indices'
          });
        }
      }).then(res => {
        if (res) {
          this.tableData = res.result;
          this.total = res.total;
          this.pageLoading = false
        }
      });
    },
    dialogClose: function (done) {
      this.form = {
        manRegionId: '',
        branchName: '',
        areaCode: '',
        phone: '',
        extension: '',
        branchCode:''
      }
      if (done) {
        done()
      }
    }
  },
  
};
</script>

<style scoped>
.btn {
  margin-left: 20px;
}
.dialog-footer {
  display: flex;
  justify-content: space-around;
}
img {
  width: 100px;
}
.demo-form-inline >>> .el-form-item__label {
  width: auto;
}
</style>
